var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdapterRmToMtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.1,14.4h-.1v-6.9H20v7l-7.6,2.2v9.9l7.7,2.2,6.1,2v27.6h2.9v9.1h-3.1v5.5h28v-5.5h-3.1v-9.1h2.9v-27.6l6.4-2,7.4-2.2v-9.9l-7.5-2.3Zm-1.1-5.9v5.9h-13v-4.3h-11.9v4.3h-13v-5.9h37.9Zm-6,63.4h-26v-3.5h26v3.5Zm-3.2-4.5h-19.6v-9.1h19.7v9.1h-.1Zm16.7-41.6l-6.7,2-7.1,2.3v27.3h-25.4v-27.3l-6.8-2.3-7-2v-4.3h24.1v9.7h4.9v-9.7h24.1v4.3h-.1Zm-53-5.3v-3l7-2.1h39.4l6.7,2v3H13.5v.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdapterRmToMtc);
export default __webpack_public_path__ + "static/media/adapterRmToMtc.521166050080cae0179ee2c6a76c2237.svg";
export { ForwardRef as ReactComponent };